import * as React from 'react';
import React__default, { useContext, createContext } from 'react';
import { n as niTrackEvent } from './ui-tracker-7f3b141f.esm.js';
export { n as niTrackEvent, t as trackShowMore } from './ui-tracker-7f3b141f.esm.js';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _extends from '@babel/runtime/helpers/esm/extends';

var TrackerContext = /*#__PURE__*/createContext({});

function useTrackerContext() {
  return useContext(TrackerContext);
}

function useTracker() {
  var _useTrackerContext = useTrackerContext(),
      trackEvent = _useTrackerContext.trackEvent;

  return trackEvent;
}

function TrackerContextProvider(props) {
  var children = props.children;
  return /*#__PURE__*/React__default.createElement(TrackerContext.Provider, {
    value: {
      trackEvent: niTrackEvent
    }
  }, children);
}

var UIEventType;

(function (UIEventType) {
  UIEventType["click"] = "click";
  UIEventType["componentImpression"] = "componentImpression";
  UIEventType["hover"] = "hover";
  UIEventType["load"] = "load";
})(UIEventType || (UIEventType = {}));

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var ClickHandler = /*#__PURE__*/function () {
  function ClickHandler() {
    _classCallCheck(this, ClickHandler);
  }

  _createClass(ClickHandler, [{
    key: "handle",
    value: function handle(el, attributes) {
      el.addEventListener('click', function () {
        niTrackEvent({
          category: attributes.category,
          action: attributes.action,
          optLabel: attributes.label,
          optValue: attributes.value,
          optNonInteraction: attributes.nonInteraction
        });
      });
    }
  }, {
    key: "shouldHandle",
    value: function shouldHandle(eventType) {
      return eventType === UIEventType.click;
    }
  }]);

  return ClickHandler;
}();

var ComponentImpressionHandler = /*#__PURE__*/function () {
  function ComponentImpressionHandler() {
    _classCallCheck(this, ComponentImpressionHandler);
  }

  _createClass(ComponentImpressionHandler, [{
    key: "handle",
    value: function handle(el, attributes) {
      var scrollableElement = document;

      if (attributes.impressionScrollableElementId) {
        var element = document.querySelector("#".concat(attributes.impressionScrollableElementId));

        if (element) {
          scrollableElement = element;
        }
      }

      scrollableElement.addEventListener('scroll', function scrollEventHandler() {
        if (ComponentImpressionHandler.isInViewport(el)) {
          niTrackEvent({
            category: attributes.category,
            action: attributes.action,
            optLabel: attributes.label,
            optValue: attributes.value,
            optNonInteraction: attributes.nonInteraction
          });
          scrollableElement.removeEventListener('scroll', scrollEventHandler);
        }
      }, false);
    }
  }, {
    key: "shouldHandle",
    value: function shouldHandle(eventType) {
      return eventType === UIEventType.componentImpression;
    }
  }], [{
    key: "isInViewport",
    value: function isInViewport(el) {
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  }]);

  return ComponentImpressionHandler;
}();

var HoverHandler = /*#__PURE__*/function () {
  function HoverHandler() {
    _classCallCheck(this, HoverHandler);
  }

  _createClass(HoverHandler, [{
    key: "handle",
    value: function handle(el, attributes) {
      el.addEventListener('mouseenter', function () {
        niTrackEvent({
          category: attributes.category,
          action: attributes.action,
          optLabel: attributes.label,
          optValue: attributes.value,
          optNonInteraction: attributes.nonInteraction
        });
      });
    }
  }, {
    key: "shouldHandle",
    value: function shouldHandle(eventType) {
      return eventType === UIEventType.hover;
    }
  }]);

  return HoverHandler;
}();

var NON_UI_EVENTS_TAGS = new Set(['STYLE', 'SCRIPT']);
var eventHandlers = [ClickHandler, ComponentImpressionHandler, HoverHandler];
var uiEventsAttributesMap = {
  type: 'data-ui-event-type',
  category: 'data-ui-event-category',
  action: 'data-ui-event-action',
  label: 'data-ui-event-label',
  value: 'data-ui-event-value',
  nonInteraction: 'data-ui-event-non-interaction',
  impressionScrollableElementId: 'data-ui-event-impression-scrollable-element'
};

function getElementToAddEvent(element) {
  if (element.nextElementSibling) {
    var nextSiblingTagName = element.nextElementSibling.tagName;
    var isSiblingElementEligibleForUIEvent = !NON_UI_EVENTS_TAGS.has(nextSiblingTagName);

    if (isSiblingElementEligibleForUIEvent) {
      return element.nextElementSibling;
    }

    return getElementToAddEvent(element.nextElementSibling);
  }

  return;
}

var initGenericUIEvents = function initGenericUIEvents() {
  var requiredKeys = [uiEventsAttributesMap.type, uiEventsAttributesMap.category, uiEventsAttributesMap.action];

  var isAttributesValid = function isAttributesValid(element) {
    return requiredKeys.every(function (key) {
      var elAttribute = element.getAttribute(key);
      var isEventTypeInvalid = key === uiEventsAttributesMap.type && !(elAttribute in UIEventType);

      if (isEventTypeInvalid) {
        return false;
      }

      return !!elAttribute;
    });
  };

  window.addEventListener('load', function () {
    var elements = document.querySelectorAll("[".concat(uiEventsAttributesMap.type, "]"));

    if (elements.length === 0) {
      return;
    }

    var _iterator = _createForOfIteratorHelper(elements),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;

        if (!isAttributesValid(el)) {
          continue;
        }

        var elementToAddEvent = getElementToAddEvent(el);
        var attributes = {
          type: el.getAttribute(uiEventsAttributesMap.type),
          category: el.getAttribute(uiEventsAttributesMap.category) || '',
          action: el.getAttribute(uiEventsAttributesMap.action) || '',
          label: el.getAttribute(uiEventsAttributesMap.label) || '',
          value: Number(el.getAttribute(uiEventsAttributesMap.value)) || 0,
          nonInteraction: el.getAttribute(uiEventsAttributesMap.nonInteraction) === 'true',
          impressionScrollableElementId: el.getAttribute(uiEventsAttributesMap.impressionScrollableElementId) || ''
        };

        if (elementToAddEvent) {
          var _iterator2 = _createForOfIteratorHelper(eventHandlers),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var eventHandler = _step2.value;
              var eventHandlerInstance = new eventHandler();

              if (eventHandlerInstance.shouldHandle(attributes.type)) {
                eventHandlerInstance.handle(elementToAddEvent, attributes);
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
};

var exportedForTesting = {
  getElementToAddEvent: getElementToAddEvent
};

var buildDataAttributes = function buildDataAttributes(data) {
  var dataKeys = Object.keys(data);
  var filteredDataKeys = {};

  for (var _i = 0, _dataKeys = dataKeys; _i < _dataKeys.length; _i++) {
    var key = _dataKeys[_i];

    if (uiEventsAttributesMap[key]) {
      filteredDataKeys[uiEventsAttributesMap[key]] = data[key];
    }
  }

  return filteredDataKeys;
};

function isValidReactElement(reactElement) {
  return /*#__PURE__*/React.isValidElement(reactElement);
}

function withUIEvent(Component, options) {
  var renderComponent = function renderComponent(props) {
    if (isValidReactElement(Component)) {
      return Component;
    }

    return /*#__PURE__*/React.createElement(Component, props);
  };

  return function (props) {
    var data = buildDataAttributes(options);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("script", _extends({
      "data-testid": "ui-event-script-tag"
    }, data)), renderComponent(props));
  };
}

export { TrackerContextProvider, UIEventType, exportedForTesting, initGenericUIEvents, uiEventsAttributesMap, useTracker, useTrackerContext, withUIEvent };
